// Generates a printable / downloadable spec sheet for a product.
export function downloadSpecSheet(p) {
  const phys = p.physical || {};
  const micro = p.microbiological || {};
  const win = window.open("", "_blank");
  if (!win) return;
  const html = `<!doctype html><html><head><meta charset="utf-8"/>
  <title>Clara Spec Sheet ${p.code}</title>
  <style>
    @page { margin: 28mm 20mm; }
    body { font-family: 'Courier New', monospace; color: #1A120D; padding: 24px; }
    .hd { border-bottom: 3px solid #B5451B; padding-bottom: 16px; margin-bottom: 24px; display:flex; justify-content:space-between; align-items:flex-end;}
    .brand { font-family: Georgia, serif; font-size: 34px; letter-spacing: 4px; color:#B5451B; }
    .sub { font-size: 11px; letter-spacing: 2px; text-transform: uppercase; color:#5C4A42; }
    h1 { font-family: Georgia, serif; font-size: 28px; margin: 0 0 4px; }
    .meta { font-size: 12px; color:#5C4A42; margin-bottom: 24px; }
    h2 { font-size: 12px; letter-spacing: 2px; text-transform: uppercase; border-bottom:1px solid #1A120D; padding-bottom:6px; margin-top:28px;}
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    td { padding: 8px 4px; border-bottom: 1px solid #ddd; }
    td:first-child { color:#5C4A42; width: 45%; }
    .note { margin-top: 20px; font-size: 11px; color:#5C4A42; font-style: italic;}
    .ft { margin-top: 40px; font-size: 10px; color:#5C4A42; border-top:1px solid #ddd; padding-top:12px;}
  </style></head><body>
  <div class="hd"><div><div class="brand">CLARA</div><div class="sub">Crafting Cocoa Excellence</div></div>
  <div class="sub" style="text-align:right">PT Tan Putra Tama<br/>Bekasi, Indonesia</div></div>
  <h1>${p.code} — ${p.color} Cocoa Powder</h1>
  <div class="meta">Type: ${p.type} · pH: ${p.ph}</div>
  <h2>Physical Characteristics</h2>
  <table>
    <tr><td>Color</td><td>${p.color}</td></tr>
    <tr><td>pH</td><td>${p.ph}</td></tr>
    <tr><td>Flavor</td><td>${phys.flavor}</td></tr>
    <tr><td>Fat Content</td><td>${phys.fat_content}</td></tr>
    <tr><td>Fineness</td><td>${phys.fineness}</td></tr>
    <tr><td>Moisture</td><td>${phys.moisture}</td></tr>
    <tr><td>Shell Content</td><td>${phys.shell_content}</td></tr>
  </table>
  <h2>Packaging &amp; Shelf Life</h2>
  <table>
    <tr><td>Packaging</td><td>25 kg, 3-ply kraft paper bag</td></tr>
    <tr><td>Shelf Life</td><td>2 years</td></tr>
  </table>
  <h2>Microbiological Specifications</h2>
  <table>
    <tr><td>Total Plate Count</td><td>${micro.total_plate_count}</td></tr>
    <tr><td>Yeast</td><td>${micro.yeast}</td></tr>
    <tr><td>Mold</td><td>${micro.mold}</td></tr>
    <tr><td>Enterobacteriaceae</td><td>${micro.enterobacteriaceae}</td></tr>
    <tr><td>Salmonella</td><td>${micro.salmonella}</td></tr>
    <tr><td>E. Coli</td><td>${micro.e_coli}</td></tr>
    <tr><td>Coliform</td><td>${micro.coliform}</td></tr>
  </table>
  <div class="note">${p.note || "*Can be customized on request"}</div>
  <div class="ft">Halal Indonesia · ISO 9001:2015 · ISO 22000 · SNI Indonesia · BPOM · marketing@tanputratama.co.id · +6221 826 10031</div>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  win.document.write(html);
  win.document.close();
}

// Generates a printable side-by-side comparison of selected grades.
// rows: [[label, (product) => value], ...] — labels pre-translated by the caller.
export function downloadComparison(products, rows) {
  const win = window.open("", "_blank");
  if (!win) return;
  const head = products
    .map((p) => `<th><div class="code">${p.code}</div><div class="cmeta">${p.type} · ${p.color} · pH ${p.ph}</div></th>`)
    .join("");
  const body = rows
    .map(([label, fn]) => {
      const vals = products.map(fn);
      const diff = new Set(vals).size > 1;
      return `<tr><td>${label}</td>${vals.map((v) => `<td class="${diff ? "diff" : ""}">${v}</td>`).join("")}</tr>`;
    })
    .join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"/>
  <title>Clara Grade Comparison</title>
  <style>
    @page { margin: 24mm 16mm; }
    body { font-family: 'Courier New', monospace; color: #1A120D; padding: 24px; }
    .hd { border-bottom: 3px solid #B5451B; padding-bottom: 16px; margin-bottom: 24px; display:flex; justify-content:space-between; align-items:flex-end;}
    .brand { font-family: Georgia, serif; font-size: 34px; letter-spacing: 4px; color:#B5451B; }
    .sub { font-size: 11px; letter-spacing: 2px; text-transform: uppercase; color:#5C4A42; }
    h1 { font-family: Georgia, serif; font-size: 26px; margin: 0 0 20px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th { text-align: left; border-bottom: 2px solid #1A120D; padding: 8px 6px; vertical-align: bottom; }
    .code { font-family: Georgia, serif; font-size: 22px; }
    .cmeta { font-size: 10px; color:#5C4A42; font-weight: normal; margin-top: 4px; }
    td { padding: 8px 6px; border-bottom: 1px solid #ddd; }
    td:first-child { color:#5C4A42; width: 24%; }
    .diff { background: #F3E0D3; font-weight: bold; }
    .ft { margin-top: 32px; font-size: 10px; color:#5C4A42; border-top:1px solid #ddd; padding-top:12px;}
  </style></head><body>
  <div class="hd"><div><div class="brand">CLARA</div><div class="sub">Crafting Cocoa Excellence</div></div>
  <div class="sub" style="text-align:right">PT Tan Putra Tama<br/>Bekasi, Indonesia</div></div>
  <h1>Grade Comparison</h1>
  <table><thead><tr><th></th>${head}</tr></thead><tbody>${body}</tbody></table>
  <div class="ft">Halal Indonesia · ISO 9001:2015 · ISO 22000 · SNI Indonesia · BPOM · marketing@tanputratama.co.id · +6221 826 10031</div>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;
  win.document.write(html);
  win.document.close();
}
